/**
 * Resource danh mục tài khoản kết chuyển
 * ntduong2 24/4/2023
 */
export default {
  Title: 'Tài khoản kết chuyển',
  Dictionary: 'Danh mục',
  FolderPath: '/ Tài khoản / Tài khoản kết chuyển',
  AccountTransferCode: 'Mã kết chuyển *',
  TransferOrder: 'Thứ tự',
  TransferSide: 'Bên kết chuyển',
  FromAccount: 'Kết chuyển từ *',
  ToAccount: 'Kết chuyển đến *',
  BusinessType: 'Loại nghiệp vụ',
  Description: 'Diễn giải',
};
